<template>
<div id="menu">

  <div id="hamburger-menu" @click="openHamburger">
    <span class="hamburger-bars"></span>
  </div>

  <div class="menu-content" v-if="!offer">
    <a
      v-for="m in content"
      :key="m.id"
      :href="`#${m.tag}`"
      v-scroll-to="{
        el: `#${m.tag}`,
        duration: 700,
        offset: vstOffset,
        onStart: openHamburger,
      }"
      class="menu-button"
    >{{ m.content | uppercase }}</a>
  </div>

  <div class="menu-content" v-if="offer">
    <router-link to="/" @click.native="openHamburger">Strona Główna</router-link>
    <router-link to="/oferta" @click.native="openHamburger">Oferta</router-link>
  </div>

</div>
</template>

<script>
export default {
  name: 'Menu',
  props: { content: Array, offer: Boolean },
  filters: {
    uppercase: value => value.toUpperCase(),
  },
  data() {
    return {
      vstOffset: -50,
    };
  },
  methods: {
    openHamburger: () => {
      document.querySelectorAll('.hamburger-bars')[0].classList.toggle('hamburger-active');
      document.querySelectorAll('.menu-content')[0].classList.toggle('menu-open');
    },

    handleResize() {
      const width = window.innerWidth;

      if (width < 768) this.vstOffset = -50;
      else if (width < 1200) this.vstOffset = -90;
      else this.vstOffset = -105;
    },

    handleScroll() {
      const scroll = window.scrollY;
      const wHeight = window.innerHeight;
      const wWidth = window.innerWidth;

      if (wWidth >= 1200) {
        const menu = document.querySelector('.menu-content');

        if (scroll >= wHeight) menu.classList.add('menu-sticky');
        else menu.classList.remove('menu-sticky');
      }
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
    this.handleResize();
  },
};
</script>

<style scoped lang="scss">
  #hamburger-menu {
    position: fixed;
    top: 0; right: 0;
    width: 50px; height: 50px;
    cursor: pointer;
    z-index: 10;

    @media (min-width: 768px) { display: none }
  }

  .hamburger-bars {
    $hb-width: 35px;
    $hb-height: 3px;
    $hb-spacing: 10.5px;

    left: calc(50% - calc(#{$hb-width} / 2));
    top: calc(50% - calc(#{$hb-height} / 2));

    &, &::before, &::after {
      position: absolute;
      width: $hb-width; height: $hb-height;
      background-color: black;
      border-radius: 2px;
    }

    &::before, &::after { content: ''; display: block; }

    &::before {
      top: -$hb-spacing;
      transition: top 100ms 250ms ease-in, transform 220ms ease-in-out;
    }

    &::after {
      top: $hb-spacing;
      transition: top 100ms 250ms ease-in, transform 220ms ease-in-out;
    }
  }

  .hamburger-active {
    transform: rotate(225deg);
    transition: transform 220ms 120ms ease-in-out;

    &::before {
      top: 0;
      transition: top 100ms ease-out;
    }

    &::after {
      top: 0;
      transform: rotate(-90deg);
      transition: bottom 100ms ease-out, transform 220ms 120ms ease-in-out;
    }
  }

  .menu-content {
    padding: 15px 0;
    position: fixed;
    left: 0; top: 50px;
    width: 100%; height: calc(100vh - 50px);
    z-index: 9;

    display: flex; flex-direction: column;
    align-items: center;

    background-color: #f2f2f2;
    box-shadow: 0 3px 3px 0 rgba(0,0,0,0.4);

    color: black;
    text-align: center;
    font-weight: bold;
    font-family: 'Josefin Sans', sans-serif;

    a {
      position: relative;
      width: 100%;
      font-size: 1.5em;
      line-height: 2em;
    }

    @media (min-width: 768px) {
      height: 40px; top: 50px;
      flex-direction: row;

      a {
        font-size: 1em;
        line-height: 43px;
        height: 40px;
        overflow: hidden;
        z-index: 1;

        &::after {
          display: block; content: '';
          position: absolute;
          width: 100%; height: 40px;
          background-color: #d6d6d6;
          top: 0;
          right: -100%;
          z-index: -1;
          transition: transform 200ms 50ms ease-in-out;
        }

        &:hover::after {
          transform: translateX(-100%);
        }
      }

      transform: none;
    }

    @media (min-width: 1200px) {
      width: 1000px;
      height: 55px;
      left: calc(50vw - 500px);

      font-size: 1.3em;

      &::before, &::after {
        display: block; content: '';
        position: absolute;
        width: 0; height: 0;
        border-top: 100px solid #f2f2f2;
        top: -45px
      }

      &::before {
        border-left: 100px solid transparent;
        left: -100px;
      }

      &::after {
        border-right: 100px solid transparent;
        right: -100px;
      }

      a {
        height: 55px;
        line-height: 60px;

        &::after { height: 55px }
      }
    }

    transform: translate3d(101%, 0, 0);
    transition: transform 200ms 50ms ease-in-out;
  }

  .menu-open { transform: translate3d(0, 0, 0); }

  .menu-sticky {
    width: 100%; left: 0;
  }
</style>
